import { useStickyError } from '../../hooks/useStickyError.ts';
import { trpc } from '../../utils/trpc/trpc.ts';

const AUTO_TASKS_REFETCH_INTERVAL_MS = 5_000;

interface Props {
    pauseFetching: boolean;
}

export function useFetchData({ pauseFetching }: Props) {

    const {
        data: autoTasks,
        error: autoTasksError,
        isLoading: autoTasksLoading,
    } = trpc.tasks.getAutoTasks.useQuery(undefined, {
        refetchInterval: AUTO_TASKS_REFETCH_INTERVAL_MS,
        enabled: !pauseFetching,
    });

    const {
        data: manualTasksOpen,
        error: manualTasksError,
        isLoading: manualTasksLoading,
        refetch: refetchManualTasks
    } = trpc.tasks.getManualTasks.useQuery(
        {
            isCompleted: false,
            isCanceled: false,
            sort: { scheduledAt: 1 }
        },
        {
            refetchInterval: 20_000,
            enabled: !pauseFetching,
        }
    );
    const manualTasksCurrent = manualTasksOpen?.filter(task => +(task.scheduledAt ?? 0) <= +new Date());
    const manualTasksScheduled = manualTasksOpen?.filter(task => +(task.scheduledAt ?? 0) > +new Date());

    const { data: notice, refetch: refetchNotice } = trpc.notice.get.useQuery(undefined, {
        refetchInterval: 60_000,
    });

    const { data: worstEquipments } = trpc.equipments.getWorstEquipments.useQuery(undefined, {
        refetchInterval: 60_000,
    });

    const { data: pageIssues } = trpc.serverState.pageIssues.useQuery(undefined, {
        refetchInterval: 10_000,
        enabled: !pauseFetching,
    });

    const stickyAutoTaskError = useStickyError({ error: autoTasksError, isLoading: autoTasksLoading });
    const stickyManualTaskError = useStickyError({ error: manualTasksError, isLoading: manualTasksLoading });

    return {
        autoTasks,
        autoTasksError: stickyAutoTaskError,
        manualTasksCurrent,
        manualTasksScheduled,
        manualTasksError: stickyManualTaskError,
        refetchManualTasks,
        notice,
        refetchNotice,
        worstEquipments,
        pageIssues
    };
}
